import { useCallback, useEffect } from 'react';
import Page from '../../../../components/page/Page';
import Header from '../../../../components/administration/warehouses/Header';
import { IconButton, Paper } from '@mui/material';
import { DataGrid, GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import useThemeMediaQuery from '../../../../../core/hooks/useThemeMediaQuery';
import { useNavigationCore } from '../../../../../core/router/navigation';
import { useMeCore } from '../../../../../core/modules/me';
import { useGlobalCore } from '../../../../../core/modules/global';
import CreateDialog from '../../../../components/administration/warehouses/CreateDialog';
import UpdateDialog from '../../../../components/administration/warehouses/UpdateDialog';
import { useCompanyCore } from '../../../../../core/modules/company';
import EditIcon from '@mui/icons-material/Edit';
import { UPDATE_STORE_DIALOG } from '../../../../../core/constants/dialog';
import { Warehouse } from '../../../../../core/interfaces/warehouse.interface';
import { useWarehouseCore } from '../../../../../core/modules/warehouse';
import { useMasterCore } from '../../../../../core/modules/master';

const Warehouses = () => {
  const { user } = useMeCore();
  const { openDialog } = useGlobalCore();
  const { companyId } = useCompanyCore();
  const { warehouses, setWarehouse, getWarehouses } = useWarehouseCore();
  const { getTypes } = useMasterCore();
  const { goToWelcome } = useNavigationCore();

  const isMobile = useThemeMediaQuery((theme) => theme.breakpoints.down('lg'));

  useEffect(() => {
    if (
      !user ||
      (
        !user.privileges.superAdmin &&
        !user.privileges.writeWarehouse &&
        !user.privileges.readWarehouse
      )
    ) {
      goToWelcome();
    }
  }, [user, goToWelcome]);

  useEffect(() => {
    if (companyId) {
      getWarehouses(companyId);
    }
  }, [companyId, getWarehouses]);

  const selectWarehouse = useCallback((store: Warehouse) => {
    if (companyId) {
      getTypes(companyId, 'warehouse');
      getTypes(companyId, 'channel');
    }
    setWarehouse(store);
    openDialog(UPDATE_STORE_DIALOG);
  }, [companyId, getTypes, openDialog, setWarehouse]);

  const columns: GridColDef[] = [
    {
      field: 'code',
      headerName: 'Código',
      flex: 1,
    },
    {
      field: 'description',
      headerName: 'Descripción',
      flex: 1,
    },
    {
      field: 'address',
      headerName: 'Dirección',
      flex: 1,
    },
    {
      field: 'actions',
      headerName: '',
      cellClassName: 'text-end',
      renderCell: (params: GridRenderCellParams) => (
        <IconButton aria-label="edit" onClick={() => selectWarehouse(params.row)}>
          <EditIcon />
        </IconButton>
      )
    },
  ];

  return (
    <>
      <Page
        header={<Header />}
        content={
          <div className="w-full my-16 px-24 md:px-32">
            <Paper className="flex flex-col flex-auto items-center shadow rounded-2xl overflow-hidden">
              <div className="w-full p-32">
                <DataGrid
                  rows={warehouses}
                  columns={columns}
                  sx={{ border: 0 }}
                  disableColumnSorting
                  disableColumnFilter
                  disableRowSelectionOnClick
                  disableMultipleRowSelection
                  hideFooter
                  pagination={undefined}
                />
              </div>
            </Paper>
          </div>
        }
        scroll={isMobile ? 'normal' : 'content'}
      />
      <CreateDialog />
      <UpdateDialog />
    </>
  );
};

export default Warehouses;
